import React from 'react';
import { HiX } from 'react-icons/hi';
import { router } from '@inertiajs/react';
import { useNoteTabs } from '@/contexts/NoteTabsContext';
import { useNotesStore } from '@/store/notesStore';

const Tabs: React.FC = () => {
  const { tabs, activeTabId, removeTab } = useNoteTabs();
  const notes = useNotesStore((state) => state.notes);

  const handleTabClick = (id: string) => {
    router.visit(`/app/note/${id}`);
  };

  const handleTabClose = (e: React.MouseEvent, id: string) => {
    e.stopPropagation();
    removeTab(id);

    // If closing active tab, navigate to notes list
    if (activeTabId === id) {
      router.visit('/app');
    }
  };

  if (tabs.length === 0) {
    return null;
  }

  return (
    <div className="flex items-start gap-0.5 overflow-x-auto pb-0.5 pr-2 -mt-0.5">
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`
            relative flex items-center gap-1.5 px-2.5 cursor-pointer
            group min-w-[80px] max-w-[160px] py-1
            ${activeTabId === tab.id 
              ? 'bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 rounded-b-lg border-b border-l border-r border-t-2 border-gray-300 dark:border-gray-700 border-t-white dark:border-t-gray-900 z-20' 
              : 'bg-gray-100/50 dark:bg-gray-800/50 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-gray-100 rounded-b-lg border-t-2 border-l border-r border-b border-t-transparent border-l-transparent border-r-transparent border-b-transparent'
            }
          `}
          onClick={() => handleTabClick(tab.id)}
        >
          <span className="flex-1 truncate text-xs font-medium">
            {tab.title}
          </span>
          {notes.find((note) => note.id === tab.id)?.encrypted && (() => {
            const encryptedNote = notes.find((note) => note.id === tab.id)!;
            return <span className="text-[10px]" title={encryptedNote.body_locked ? 'Encrypted and locked' : 'Encrypted and unlocked'} aria-label={encryptedNote.body_locked ? 'Encrypted and locked' : 'Encrypted and unlocked'}>{encryptedNote.body_locked ? '🔒' : '🔓'}</span>;
          })()}
          <button
            onClick={(e) => handleTabClose(e, tab.id)}
            className={`
              flex-shrink-0 p-0.5 rounded
              ${activeTabId === tab.id
                ? 'opacity-70 hover:opacity-100 hover:bg-gray-200 dark:hover:bg-gray-700' 
                : 'opacity-0 group-hover:opacity-70 hover:opacity-100 hover:bg-gray-200 dark:hover:bg-gray-700'
              }
            `}
            aria-label="Close tab"
          >
            <HiX className="w-3 h-3" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default Tabs;
